// ✅ src/data/projectsData.js

const projectsData = [
  {
    id: 11,
    title: "talkup.ai",
    description:
      "Fully AI-driven language translator assistant that breaks down language barriers and enables seamless communication across the globe. ",
    image: "../assets/projects/image1.png", // optional image
  }, 
  {
    id: 12,
    title: "xtrology.com",
    description:
      "Next-generation astrology app that harnesses the power of artificial intelligence (AI) and machine learning (ML) and quantum vedics to provide a comprehensive and personalized astrological experience.",
    image: "../assets/projects/image1.png", // optional image
  },
  {
    id: 1,
    title: "Defense Simulation Systems",
    description:
      "High-performance simulation and training systems developed for advanced defense operations and tactical training.",
    image: "../assets/projects/image1.png", // optional image
  },
  {
    id: 2,
    title: "AI-Powered Surveillance",
    description:
      "Intelligent surveillance systems leveraging AI for real-time threat detection and analytics.",
    image: "../assets/projects/image2.png",
  },
  {
    id: 3,
    title: "Autonomous Drone Program",
    description:
      "Fully autonomous drone platform supporting reconnaissance, logistics, and defense operations.",
    image: "../assets/projects/image3.png",
  },
  {
    id: 4,
    title: "Defense IoT Infrastructure",
    description:
      "Smart IoT-enabled defense monitoring and predictive maintenance system to enhance operational readiness.",
    image: "../assets/projects/image4.png",
  },
];

export default projectsData;
